const colors = require('tailwindcss/colors')

module.exports = {
  purge: [],
  theme: {
    container: {
      center: true,
      padding: {
        DEFAULT: '1rem'
      },
    },
    fontFamily: {
      sans: [
        'DM Sans'
      ],
      two: [
        'Univia Pro'
      ],
      three: [
        'Barlow',
        'system-ui',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        '"Noto Sans"',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"',
      ],
      serif: ['Barlow', 'Georgia', 'Cambria', '"Times New Roman"', 'Times', 'serif'],
      mono: ['Roboto', 'Monaco', 'Consolas', '"Liberation Mono"', '"Courier New"', 'monospace'],
    },
    screens: {
      xs: {'min': '480px'},
      sm: {'min': '640px'},
      md: {'min': '768px'},
      lg: {'min': '1024px'},
      xl: {'min': '1280px'},
      xxl: {'min': '1441px'},
      wide: {'min': '1601px'},
      ultra_wide: {'min': '1901px'},
      landscape: {'raw': '(orientation: landscape) and (max-width: 1280px)'},
      phone_landscape: {'raw': '(orientation: landscape) and (max-width: 1024px)'},
      mini_landscape: {'raw': '(orientation: landscape) and (max-width: 640px)'},
      print: {'raw': 'print'},
    },
    extend: {
      colors: {
        primary: {
          light: '#A9D1CC',
          default: '#288B80',
          dark: colors.coolGray['900'],
        },
        secondary: {
          light: '#FBFBFB',
          default: '#f5f5f5',
          dark: '#626262',
        },
        accent: {
          light: colors.sky['200'],
          default: colors.sky['500'],
          dark: colors.sky['900'],
        },
        neutral: {
          ultralight: colors.blueGray['100'],
          light: colors.coolGray['200'],
          default: colors.blueGray['300'],
          lightdark: colors.blueGray['500'],
          dark: colors.blueGray['600'],
          ff: colors.blueGray['800'],
        },
        vivid: {
          light: '#EFB1B2',
          default: '#D63D3F',
          dark: '#561819',
        },
        white: '#FFFFFF',
        black: '#000'
      },
      maxWidth: {
        '1/4': '25%',
        '1/2': '50%',
        '3/4': '75%',
      },
      maxHeight: {
        '100': '25rem',
      },
      minHeight: {
        '20': '5rem',
        '96': '24rem',
      },
      scale: {
        '101': '1.002'
      },
      borderWidth: {
        '3': '3px',
      },
      boxShadow: {
        DEFAULT: '0px 4px 8px rgba(0, 0, 0, 0.04)'
      },
      transitionProperty: {
        'scale': 'height, width, max-height',
      },
      minWidth: {
        'aside': '23rem'
      },
      height: {
        '1/2-screen': '50vh',
        '9/12-screen': '75vh',
        '10/12-screen': '85vh',
      },
      spacing: {
        '104': '26rem',
        '110': '28rem',
        '118': '30rem',
        '126': '32rem',
        '132': '34rem',
        '140': '36rem',
        '148': '38rem',
        '156': '40rem',
        '162': '42rem',
        '170': '44rem'
      },
      typography: (theme) => ({
        // DEFAULT: {
        //   css: {
        //     color: theme('colors.white'),
        //   },
        // },
      }),
    },
  },
  variants: {
    padding: ['responsive', 'odd', 'even'],
    textColor: ['responsive', 'hover', 'focus', 'group-hover'],
    borderStyle: ['responsive', 'focus'],
    extend: {
      backgroundColor: ['disabled'],
      opacity: ['disabled'],
      cursor: ['disabled'],
    }
  },
  plugins: [
    require('@tailwindcss/forms'),
    require('@tailwindcss/typography'),
  ],
  prefix: ''
}
